<template>
  <div
    v-if="flashcardMetadata"
    class="flashcard-metadata"
  >
    <span class="grouped-icon">
      <span class="gray-pill">
        <icon name="users"></icon>
      </span>
      Answered {{ flashcardMetadata.totalAnswers.toLocaleString() }} times
    </span>
    <span class="grouped-icon">
      <span class="gray-pill">
        <icon name="bar-chart"></icon>
      </span>
      {{ flashcardMetadata.correctPercent }}% Correct
    </span>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';
import FlashcardMetadataMixin from '@/mixins/flashcardMetadata.js';

export default {
  name: 'FlashcardMetadata',
  components: { Icon },
  mixins: [FlashcardMetadataMixin],
  props: {
    flashcard: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.flashcard-metadata {
  display: flex;
  color: rgba(105, 117, 134, 1);
  font-size: rem-calc(14);
  font-weight: 600;
  line-height: rem-calc(20);
  gap: rem-calc(20);
  padding-bottom: rem-calc(16);

  .grouped-icon {
    display: flex;
    align-items: center;
    gap: rem-calc(8);

    .gray-pill {
      display: grid;
      place-items: center;
      width: rem-calc(24);
      height: rem-calc(24);
      background: rgba(248, 250, 252, 1);
      border-radius: rem-calc(4);
    }
  }
}
</style>
